// extracted by mini-css-extract-plugin
export default {"root":"style_root__evCMm","currency":"style_currency__9Fjyv"};